export const SET_OVERLAY_LOADING_SCREEN = "set_overlay_loading_screen";

export const setOverlayLoadingScreen = value => ({
  type: SET_OVERLAY_LOADING_SCREEN,
  value
});
